import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './index.css'
import { applyTheme, readTheme } from './lib/theme'
import { AuthProvider } from './lib/auth'
import MetrikaPageViews from './components/MetrikaPageViews'
import Home from './pages/Home'
import Admin from './pages/Admin'
import Present from './pages/Present'
import Play from './pages/Play'
import Decks from './pages/Decks'
import DeckEditor from './pages/DeckEditor'
import Results from './pages/Results'
import Pricing from './pages/Pricing'
import { Agreement, Requisites } from './pages/Legal'

// До первого кадра: иначе выбранная тема применится после отрисовки и экран
// на мгновение мигнёт чужими цветами.
applyTheme(readTheme())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        {/* Ничего не рисует: досылает Метрике переходы внутри SPA. */}
        <MetrikaPageViews />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/demos" element={<Decks />} />
        <Route path="/demo/:id" element={<DeckEditor />} />
        <Route path="/results/:code" element={<Results />} />
        <Route path="/legal/agreement" element={<Agreement />} />
        <Route path="/legal/requisites" element={<Requisites />} />
        <Route path="/admin/:code" element={<Admin />} />
        <Route path="/present/:code" element={<Present />} />
        <Route path="/join/:code" element={<Play />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
